
/* injects from baggage-loader */

'use strict';

export default function (app) {
	app.service('ProjectSectionSchema', function (Parse) {

		// ==================================================
		// Instantiate Objects
		// ==================================================
		let ProjectSections = Parse.Object.extend('Project_Info');

		// Define 'Project_Sections' scheme
		let schema = [
			'title',
			'body',
			'order'
		];
		
		// Load schema into object prototype
		schema.forEach(field => {
			Object.defineProperty(ProjectSections.prototype, field, {
				get: function () { return this.get(field); },
				set: function (value) { return this.set(field, value); }
			});
		});

		return ProjectSections;

	});
}




// WEBPACK FOOTER //
// ./src/app/core/schemas/project-section.schema.js